export const removeLastSlash = (uri: string) => {
  return new RegExp(/\/$/).test(uri) ? uri.slice(0, uri.length - 1) : uri;
};